import React from 'react';
import { IconCircleCheckFilled } from '@tabler/icons-react';

import { formatCents } from '@src/common';
import ProductPackageAddToCartButton from '../ProductPackageAddToCartButton';
import usePackage from '@src/hooks/usePackage';
import useTranslate from '@src/i18n/useTranslate';
import { Container } from './styles';
import { useAppSelector } from '@src/core/hooks';
import { productPackageSelector } from '@src/features/product';
import usePackageIdParam from '@src/hooks/usePackageIdParam';

const ProductPackageCompletedSummary = () => {
  const { i18n } = useTranslate();

  const packageId = usePackageIdParam();

  const productPackage = useAppSelector(productPackageSelector(packageId!));

  const { packageTotalCents, countFilledProducts } = usePackage();

  return (
    <Container>
      <strong>
        {i18n('product_package_adder_complete_selection_description', {
          packageName: productPackage!.name,
          productQuantity: String(countFilledProducts),
        })}
      </strong>
      <IconCircleCheckFilled size={32} color='#0092ff' />

      <p>
        {i18n('product_package_adder_total')}: {formatCents(packageTotalCents)}
      </p>
      <ProductPackageAddToCartButton />
    </Container>
  );
};

export default ProductPackageCompletedSummary;
